import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Survey\GetSurveyByIdController::__invoke
* @see app/Http/Controllers/Survey/GetSurveyByIdController.php
* @route '/api/survey/{survey}'
*/
const GetSurveyByIdController = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSurveyByIdController.url(args, options),
    method: 'get',
})

GetSurveyByIdController.definition = {
    methods: ["get","head"],
    url: '/api/survey/{survey}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Survey\GetSurveyByIdController::__invoke
* @see app/Http/Controllers/Survey/GetSurveyByIdController.php
* @route '/api/survey/{survey}'
*/
GetSurveyByIdController.url = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { survey: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { survey: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            survey: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        survey: typeof args.survey === 'object'
        ? args.survey.id
        : args.survey,
    }

    return GetSurveyByIdController.definition.url
            .replace('{survey}', parsedArgs.survey.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Survey\GetSurveyByIdController::__invoke
* @see app/Http/Controllers/Survey/GetSurveyByIdController.php
* @route '/api/survey/{survey}'
*/
GetSurveyByIdController.get = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSurveyByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Survey\GetSurveyByIdController::__invoke
* @see app/Http/Controllers/Survey/GetSurveyByIdController.php
* @route '/api/survey/{survey}'
*/
GetSurveyByIdController.head = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSurveyByIdController.url(args, options),
    method: 'head',
})

export default GetSurveyByIdController